import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import get from 'lodash.get'
import pickBy from 'lodash.pickby'

import Downloads from '../../templates/Downloads'
import { setDownloadsData } from '../../../actions/downloads'

class DownloadsContainer extends Component {
  async componentDidMount () {
    await setDownloadsData(this.props.getTranslations())
  }

  render () {
    return (
      <Downloads {...this.props} />
    )
  }
}

const mapStateToProps = state =>
  (Object.assign({
    downloads: get(state, 'downloads', [])
  }))

export default connect(mapStateToProps)(DownloadsContainer)



// WEBPACK FOOTER //
// ./src/components/pages/Downloads/Downloads.container.js